import { useCallback } from 'react';

// LINE
import liff from '@line/liff';

// type
interface GTagWindow extends Window {
  gtagEvent: (eventName: string, eventProps?: { [key: string]: string | number }) => void;
}
declare const window: GTagWindow;

/**
 * Flex Messageを使用したカードメッセージをシェアします
 */
export const useShareTargetPicker = () => {
  const lineShare = useCallback(() => {
    if (liff.isApiAvailable('shareTargetPicker')) {
      liff
        .shareTargetPicker([
          {
            type: 'flex',
            altText: 'プレゼントが当たる！TBS『THE TIME,』【ニュース関心調査】に回答しました！',
            contents: {
              type: 'bubble',
              hero: {
                type: 'image',
                url: 'https://images.microcms-assets.io/assets/544571337e7f44cc90d36b8c786eabbe/4a82daf092574a6d837594ec91013775/n3.png',
                size: '50%',
                aspectRatio: '1:1',
                offsetTop: 'xl',
              },
              body: {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'box',
                    layout: 'vertical',
                    contents: [
                      {
                        type: 'text',
                        text: 'TBS『THE TIME,』',
                        weight: 'bold',
                        size: '16px',
                        align: 'center',
                      },
                    ],
                  },
                  {
                    type: 'box',
                    layout: 'vertical',
                    contents: [
                      {
                        type: 'text',
                        text: '【ニュース関心調査】に回答しました！',
                        weight: 'bold',
                        size: '14px',
                        align: 'center',
                        wrap: true,
                      },
                    ],
                  },
                  {
                    type: 'text',
                    text: '放送前日よる７時〜よる９時限定⏰',
                    size: 'sm',
                    weight: 'regular',
                    align: 'center',
                    margin: 'xxl',
                  },
                  {
                    type: 'text',
                    text: '番組公式LINEから',
                    size: 'sm',
                    weight: 'regular',
                    align: 'center',
                    margin: 'xs',
                  },
                  {
                    type: 'text',
                    text: 'ニュース関心調査に参加すると​​',
                    size: 'sm',
                    weight: 'regular',
                    align: 'center',
                    margin: 'xs',
                  },
                  {
                    type: 'text',
                    text: 'プレゼントが当たるチャンス🤳',
                    size: 'sm',
                    weight: 'regular',
                    align: 'center',
                    margin: 'xs',
                  },
                ],
              },
              footer: {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'button',
                    action: {
                      type: 'uri',
                      label: 'アンケートに回答する',
                      uri: 'https://lin.ee/d1QWFLl',
                    },
                    height: 'sm',
                    style: 'primary',
                    color: '#0050FF',
                    gravity: 'center',
                    adjustMode: 'shrink-to-fit',
                  },
                ],
              },
            },
          },
        ])
        .then(() => {
          console.log('shareTargetPicker success');
          // GA：LINEシェア実行
          window.gtagEvent('share_LINE');
        })
        .catch(err => {
          console.error('shareTargetPicker error:', err);
        });
    } else {
      console.error('shareTargetPicker is not available');
    }
  }, []);

  return { lineShare };
};
